// extracted by mini-css-extract-plugin
export default {"warning":"Training_warning__pcfCX"};